export default __webpack_public_path__ + "static/media/hourglass.980cdf40.svg";